const charcoal = {
  100: "#F5F5F5",
  200: "#E6E6E6",
  300: "#BFBFBF",
  400: "#878787",
  500: "#616161",
  600: "#3E3E3E",
  700: "#2E2E2E",
  800: "#222222",
  900: "#171717",
  contrastDefaultColor: "#ffffff"
}

export default charcoal
